var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 27.4H10.4v-17h10.2V0h-4.4C5 0 0 4 0 15v29.4h20.6v-17zm29 0H39.4v-17h10.2V0h-4.4C34 0 29 4 29 15v29.4h20.6v-17z",
    fill: "url(#topQuotes_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "topQuotes_svg__paint0_linear",
    x1: 27.142,
    y1: 41.532,
    x2: 0.883,
    y2: 23.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BD7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468FBD"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTAgNDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMC42IDI3LjRIMTAuNFYxMC40SDIwLjZWMEgxNi4yQzUgMCAwIDMuOTk5OTkgMCAxNVY0NC40SDIwLjZWMjcuNFpNNDkuNiAyNy40SDM5LjRWMTAuNEg0OS42VjBINDUuMkMzNCAwIDI5IDMuOTk5OTkgMjkgMTVWNDQuNEg0OS42VjI3LjRaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIyNy4xNDIyIiB5MT0iNDEuNTMyNSIgeDI9IjAuODgyOTcxIiB5Mj0iMjMuMjU5NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNkJEN0I0Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzQ2OEZCRCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgTopQuotes as ReactComponent };